<template>
  <div>
    <div class="alert_container" v-if="!userAgent.msdk">
      <div class="alert_bg"></div>
      <!-- 分享 -->
      <div @click.self="closeShareDialog" class="alert_outbox alert_share">
        <div class="top_img"></div>
        <div class="top_tip">长按或截图保存图片，也可以直接点击右上角分享链接</div>
        <div class="share_box">
          <div id="shareContainer" v-show="!shareImg">
            <img
              alt
              class="logo"
              crossorigin="anonymous"
              src="../../../../ui/LianPoH5/images/logo.png"
            />
            <div class="img" style="background: none;">
              <img
                crossorigin="anonymous"
                src="//midas.gtimg.cn/h5/bargain/static/images/alert_share_img.b9a6714.png?r=20200904"
                style="width: 100%; height: 100%"
              />
            </div>
            <div class="text_box">
              <div class="tip">廉颇 无尽征程</div>
              <div class="left">
                <div class="title">两人成团仅60点券买【荣耀征程礼包】，得廉颇新皮肤再加30荣耀积分，快来跟你的小伙伴一起开团吧</div>
                <p>历时五年，廉颇终于有了一款新皮肤，我已经买了，你呢？</p>
              </div>
              <div class="right" id="sharecode" style="background-size: 100% auto;"></div>
            </div>
            <div class></div>
          </div>

          <img :src="shareImg" style="width: 100%;" v-show="shareImg" />
        </div>
      </div>
    </div>
    <div class="alert_container" v-else>
      <div class="alert_bg"></div>
      <div class="alert_outbox alert_pay_build">
        <div class="alert_content border_box">
          <div class="corner"></div>
          <div class="corner"></div>
          <div class="corner"></div>
          <div class="corner"></div>

          <div @click="closeShareDialog" class="close_btn"></div>
          <div class="share_box">
            <div @click="clickMsdkShareTo('pengy')" class="item pengy" v-if="accountType == 'wechat'">
              <div class="icon"></div>
              <div class="tip">分享至朋友圈</div>
            </div>
            <div @click="clickMsdkShareTo('weixin')" class="item weixin" v-if="accountType == 'wechat'">
              <div class="icon"></div>
              <div class="tip">分享至微信</div>
            </div>
            <div @click="clickMsdkShareTo('qq')" class="item qq" v-if="accountType == 'qq'">
              <div class="icon"></div>
              <div class="tip">分享至QQ</div>
            </div>
            <div @click="clickMsdkShareTo('qzone')" class="item qzone" v-if="accountType == 'qq'">
              <div class="icon"></div>
              <div class="tip">分享至空间</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as urlUtil from "../../common/utils/url"
import * as shareImgApi from "../api/shareImg"
import { mapActions, mapGetters } from "vuex"

let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  name: "ShareImgDialog",
  data() {
    return {
      shareImg: null
    }
  },
  mounted() {
    if (this.userAgent && this.userAgent.msdk) {
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.POPUP_SHARE,
        resultInfo: {
          userAgent: "MSDK",
          accountType: this.accountType == "qq" ? "QQ" : "WX"
        }
      })
    } else {
      this.$nextTick(() => {
        this.initShareImg()
      })
      this.reportUserAction({
        iformat: configs.REPORT.PAGEVIEW.POPUP_SHARE,
        resultInfo: {
          userAgent: this.userAgent.weixin ? "WX" : "QQ",
          accountType: this.accountType == "qq" ? "QQ" : "WX"
        }
      })
    }
  },
  computed: {
    ...mapGetters(["userAgent", "accountType"])
  },
  methods: {
    ...mapActions(["setToastMsg", "setLoadingStart", "setLoadingEnd", "msdkShareTo", "reportUserAction"]),
    initShareImg() {
      this.shareImg = null
      this.setLoadingStart("海报制作中，请稍等...")
      shareImgApi.generateQRCode({
        url: urlUtil.addGetParam(
          {
            pf: "__mds_tuan_shareimg",
            _wv: 49153,
            x: "x"
          },
          urlUtil.delParam(["pf", "code", "state", "partition", "roleid", "area"], location.href)
        ),
        success: url => {
          let sharecodeDom = document.getElementById("sharecode")
          if (sharecodeDom && sharecodeDom.style) sharecodeDom.style.backgroundImage = `url(${url})`

          shareImgApi
            .generateScreenShots("shareContainer")
            .then(base64Img => {
              this.setLoadingEnd()
              this.shareImg = base64Img
            })
            .catch(err => {
              this.setLoadingEnd()
              console.log(err)
              this.setToastMsg("系统繁忙，请重试")
            })
        },
        fail: err => {
          this.setLoadingEnd()
          console.log(err)
          this.setToastMsg("系统繁忙，请重试")
        }
      })
    },
    closeShareDialog() {
      this.$emit("closeShareDialog")
    },
    clickMsdkShareTo(type) {
      let tuanId = this.$route.params && this.$route.params.id ? this.$route.params.id : ""
      if (tuanId) {
        this.msdkShareTo({ selected: type, tuanId: this.$route.params.id })
      }
    }
  }
}
</script>

<style scoped>
.alert_share .share_box .text_box .right {
  width: 2.16rem;
  height: auto;
}
.alert_pay_build .alert_content .share_box .item.pengy .icon {
  background-image: url("../../../../ui/LianPoH5/images/alert/item_1.png");
}
.alert_pay_build .alert_content .share_box .item.weixin .icon {
  background-image: url("../../../../ui/LianPoH5/images/alert/item_2.png");
}
.alert_pay_build .alert_content .share_box .item.qq .icon {
  background-image: url("../../../../ui/LianPoH5/images/alert/item_3.png");
}
.alert_pay_build .alert_content .share_box .item.qzone .icon {
  background-image: url("../../../../ui/LianPoH5/images/alert/item_4.png");
}

.alert_share .logo {
  position: absolute;
  z-index: 10;
  width: 2.83rem;
  top: 0.12rem;
  left: 0.12rem;
}
</style>
